exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.primary--text{color:#e5e9ec!important;caret-color:#f4f4f4!important}", ""]);

// exports
